import React__default, { Children, isValidElement, cloneElement } from 'react';
import { C as CardStyled, a as CardBodyStyled } from './Card.styles-CUt4jM-_.js';
import { C as CardHeader } from './CardHeader-CoaLsTfs.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { i as isElementOf } from '../LocalModules/storm-ui-utils/dist/esm/isElementOf-Wg8aEFDZ-Wg8aEFDZ.js';

const isCardHeader = isElementOf(CardHeader);
const Card = ({
  children,
  isCollapsed = false,
  handleCollapseChanged,
  padding = 'base',
  paddingInlineStart,
  paddingInlineEnd,
  paddingBlockStart,
  paddingBlockEnd,
  taktId,
  taktValue,
  ...rest
}) => {
  let cardHeaderComponent;
  const childrenComponents = [];
  Children.forEach(children, child => {
    if (typeof child === 'string') {
      childrenComponents.push(child);
    }
    if (! /*#__PURE__*/isValidElement(child)) {
      return null;
    }
    if (!cardHeaderComponent && isCardHeader(child)) {
      cardHeaderComponent = child;
    } else {
      childrenComponents.push(child);
    }
    return null;
  });
  const hasCardHeaderAndIsCollapsible = cardHeaderComponent && handleCollapseChanged;
  const cardHeaderProps = hasCardHeaderAndIsCollapsible ? {
    isCollapsed,
    onCollapse: handleCollapseChanged,
    padding,
    paddingInlineStart,
    paddingInlineEnd,
    paddingBlockStart,
    paddingBlockEnd
  } : {
    padding,
    paddingInlineStart,
    paddingInlineEnd,
    paddingBlockStart,
    paddingBlockEnd
  };
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('card')
  }, /*#__PURE__*/React__default.createElement(CardStyled, rest, cardHeaderComponent && /*#__PURE__*/cloneElement(cardHeaderComponent, {
    ...cardHeaderProps,
    ...cardHeaderComponent.props
  }), /*#__PURE__*/React__default.createElement(CardBodyStyled, {
    visible: !isCollapsed,
    $padding: padding,
    $paddingInlineStart: paddingInlineStart,
    $paddingInlineEnd: paddingInlineEnd,
    $paddingBlockStart: paddingBlockStart,
    $paddingBlockEnd: paddingBlockEnd
  }, childrenComponents)));
};

export { Card as C };
//# sourceMappingURL=Card-B4HxDDFs.js.map
